import React, { useState, useEffect } from 'react';
import {
  Table,
  notification,
  Popconfirm,
  Space,
  Typography,
  Layout,
} from 'antd';
import { Link } from 'react-router-dom';

import MESSAGES from '../../../enums/Messages';
import INTERNAL_LINKS from '../../../enums/InternalLinks';
import CustomButton from '../../../components/CustomButton';
import SpinLoad from '../../../components/SpinLoad';
import PdfViewer from '../../../components/PdfViewer';

import { filter, remove } from '../../../api/module/resume_training';
import { get as getDocumentUrl } from '../../../api/module/document_repository';
import { catchException } from '../../../utils/helpers/helpers';

const { Paragraph } = Typography;
const { Content } = Layout;

const EducationContractorsList = ({ idTercero, readOnly = false }) => {
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingDocument, setLoadingDocument] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [showPdf, setShowPdf] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');

  const showClick = async (documento_nombre) => {
    setLoadingDocument(true);

    const response = await getDocumentUrl(documento_nombre);

    setPdfUrl(response.data.url);
    setShowPdf(true);
    setLoadingDocument(false);
  };

  const columns = [
    {
      title: 'Tipo educación',
      dataIndex: 'tipo_educacion_nombre',
      key: 'tipo_educacion_nombre',
    },
    {
      title: 'Nivel educativo',
      dataIndex: 'nivel_educativo_nombre',
      key: 'nivel_educativo_nombre',
    },
    {
      title: 'Estado',
      dataIndex: 'finalizado',
      key: 'finalizado',
      render: (text, record) => {
        if (record.nivel_educativo !== 1) {
          if (record.finalizado === true) {
            return 'Finalizado';
          } else {
            return 'En curso';
          }
        }
      },
    },
    {
      title: 'Título obtenido',
      dataIndex: 'titulo_nombre_programa',
      key: 'titulo_nombre_programa',
    },
    {
      title: 'Fecha de grado',
      dataIndex: 'fecha_terminacion',
      key: 'fecha_terminacion',
    },
    {
      title: 'Semestre actual',
      dataIndex: 'semestre',
      key: 'semestre',
      align: 'center',
    },
    {
      title: 'Consultar documento',
      dataIndex: 'tarjeta_profesional',
      key: 'tarjeta_profesional',
      fixed: 'right',
      align: 'center',
      width: 120,
      render: (text, record) => {
        if (record.documento_certificado_nombre) {
          return (
            <CustomButton
              block
              type="default"
              htmlType="button"
              text="Ver"
              loading={loadingDocument}
              onClick={() => {
                showClick(record.documento_certificado_nombre);
              }}
            />
          );
        }
      },
    },
    {
      title: 'Acción',
      key: 'action',
      fixed: 'right',
      width: 200,
      render: (_, record) =>
        dataSource.length >= 1 && !readOnly ? (
          <Space>
            <CustomButton
              type={'default'}
              className={'ant-btn-info'}
              htmlType="button"
              text={
                <Link
                  to={`${INTERNAL_LINKS.EDUCATION_CONTRACTORS}/${idTercero}/${record.id}`}
                >
                  Editar
                </Link>
              }
            />
            <CustomButton
              danger
              type={'default'}
              loading={loadingDelete}
              htmlType="button"
              text={
                <Popconfirm
                  title={MESSAGES.DELETE_CONFIRM_MSG}
                  onConfirm={() => deleteDataSource(record.id)}
                >
                  Eliminar
                </Popconfirm>
              }
            />
          </Space>
        ) : null,
    },
  ];

  const getDataSource = async () => {
    try {
      setLoading(true);
      const response = await filter('?filter[tercero]=' + idTercero);
      response.data.results.sort(function (a, b) {
        if (a.tipo_educacion > b.tipo_educacion) {
          return 1;
        }
        if (a.tipo_educacion < b.tipo_educacion) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });
      setDataSource(response.data.results);
      setLoading(false);
    } catch (err) {
      console.log(err);
      notification.error({
        message: MESSAGES.ERROR_MSG,
        description: MESSAGES.DESC_ERROR_GET_MSG,
        duration: 2,
      });
    }
  };

  useEffect(() => {
    if (idTercero !== undefined) getDataSource();
  }, []);

  const deleteDataSource = async (id) => {
    try {
      setLoadingDelete(true);
      const response = await remove(id);
      setLoadingDelete(false);
      if ([200, 201, 204].indexOf(response.status) > -1) {
        notification.success({
          message: MESSAGES.SUCCESS_MSG,
          description: MESSAGES.DESC_SUCCESS_DELETE_MSG,
          duration: 2,
        });
        await getDataSource();
      }
    } catch (err) {
      console.log(err);
      setLoadingDelete(false);
      catchException(err, MESSAGES.DESC_ERROR_DELETE_MSG);
    }
  };
  return (
    <Content>
      <SpinLoad loading={loading}>
        <Table
          rowKey="id"
          columns={columns}
          dataSource={dataSource}
          scroll={{ x: 1100 }}
          title={() => (
            <Paragraph className={'margin-5'} strong>
              Listado de Certificados de educación
            </Paragraph>
          )}
        />
      </SpinLoad>
      <PdfViewer
        pdf={pdfUrl}
        onCancel={() => setShowPdf(false)}
        open={showPdf}
      />
    </Content>
  );
};

export default EducationContractorsList;
